/**
 * Live Streaming EPG - Admin JavaScript
 * 
 * Handles all EPG-related JavaScript functionality in the admin area.
 */
import { post } from "./ajax";

class LSEPG {
    constructor() {
        this.init();
    }

    init() {
        // Initialize EPG functionality when document is ready
        jQuery(document).ready(($) => {
            this.setupEventListeners($);
        });
    }

    setupEventListeners($) {
        // Handle EPG data refresh button
        $('#refresh-epg-data').on('click', () => {
            this.refreshEPGData($);
        });

        // Handle EPG settings form submission
        $('#ls-epg-settings-form').on('submit', (e) => {
            this.handleSettingsFormSubmit($, e);
        });

        // Store original values for comparison in EPG settings form
        if ($('#ls-epg-settings-form').length) {
            $('[name="ls_epg_update_interval"]').data('original', $('[name="ls_epg_update_interval"]').val());
            $('[name="ls_epg_enabled"]').data('original', $('[name="ls_epg_enabled"]').prop('checked'));
        }
    }

    refreshEPGData($) {
        const button = $('#refresh-epg-data');
        const spinner = button.find('.spinner');
        
        // Disable button and show spinner
        button.prop('disabled', true);
        spinner.css('visibility', 'visible');
        
        // AJAX call to refresh EPG data
        post('ls_refresh_epg_data').then((response) => {
            if (response.success) {
                // Show success message and reload the page
                alert(response.data.message);
                location.reload();
            } else {
                // Show error message
                alert(response.data.message);
                button.prop('disabled', false);
                spinner.css('visibility', 'hidden');
            }
        }).catch((error) => {
            // Handle AJAX error
            console.error('Error refreshing EPG data:', error);
            alert(ls_epg_data.error_message);
            button.prop('disabled', false);
            spinner.css('visibility', 'hidden');
        })
       
    }

    handleSettingsFormSubmit($, e) {
        e.preventDefault();
        
        let formData = $('#ls-epg-settings-form').serialize();
        
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            success: (response) => {
                if (response.success) {
                    // Show success message
                    $('.ls-settings-message').remove();
                    $('#ls-epg-settings-form').before('<div class="notice notice-success ls-settings-message"><p>' + response.data.message + '</p></div>');
                    
                    // Reset cron schedule if update interval changed or EPG was enabled/disabled
                    if ($('[name="ls_epg_update_interval"]').data('original') !== $('[name="ls_epg_update_interval"]').val() || 
                        $('[name="ls_epg_enabled"]').prop('checked') !== $('[name="ls_epg_enabled"]').data('original')) {
                        
                        // Reload the page after a short delay to apply new settings
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                    }
                } else {
                    // Show error message
                    $('.ls-settings-message').remove();
                    $('#ls-epg-settings-form').before('<div class="notice notice-error ls-settings-message"><p>' + response.data.message + '</p></div>');
                }
            }
        });
    }
}

export default LSEPG;